import { createTheme } from '@mui/material/styles';
import brandingConfig from '../config/brandingConfig';
import { applyTheme } from '../config/whiteLabel';

// Create base theme
const baseTheme = createTheme({
  palette: {
    primary: {
      main: brandingConfig.colors.primary,
      dark: '#D4A800',
      light: '#F7D44C',
      contrastText: '#000000',
    },
    secondary: {
      main: brandingConfig.colors.secondary,
      dark: brandingConfig.colors.secondary,
      light: brandingConfig.colors.secondary,
      contrastText: '#FFFFFF',
    },
    error: {
      main: brandingConfig.colors.error,
    },
    warning: {
      main: brandingConfig.colors.warning,
    },
    info: {
      main: brandingConfig.colors.info,
    },
    success: {
      main: brandingConfig.colors.success,
    },
    background: {
      default: '#F5F5F5',
      paper: brandingConfig.colors.background,
    },
    text: {
      primary: brandingConfig.colors.text.primary,
      secondary: brandingConfig.colors.text.secondary,
      disabled: '#9E9E9E',
    },
  },
  typography: {
    fontFamily: brandingConfig.ui.fontFamily,
    h1: {
      fontWeight: 500,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 500,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: parseInt(brandingConfig.ui.borderRadius),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: brandingConfig.ui.buttonStyle === 'pill' ? 30 : 
                        brandingConfig.ui.buttonStyle === 'square' ? 4 : 8,
          padding: '8px 16px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: brandingConfig.colors.primary,
            filter: 'brightness(110%)',
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: brandingConfig.colors.secondary,
            filter: 'brightness(90%)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: parseInt(brandingConfig.ui.borderRadius) * 1.5,
          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 'bold',
          backgroundColor: '#F5F5F5',
        },
      },
    },
  },
});

// Apply any additional theme customizations
const theme = applyTheme(baseTheme);

export default theme;